<template>
  <div class="login-container">
    <!-- <el-button type="success" @click="handleLogin">登录</el-button> -->
  
    <iframe
      class="w-full h-[400px]"
      :src="`https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_login`"
      frameborder="0"
    ></iframe>

  </div>
</template>

<script>
import { isvalidUsername } from "@/utils/validate";
import request from "@/utils/request";
import { getToken, setToken, removeToken } from "@/utils/auth";

export default {
  name: "Login",
  data() {
    return {
      // 测试
      // appid: 'wx773ce6069e2bcb79',
      // redirect_uri: 'https://aizs-associate.mvp45.com',
      // 正式
      // appid: 'wx212e2480f7a1a87c',
      // redirect_uri: 'https://antbot-associate.hspaces.cn',
      appid: process.env.VUE_APP_APPID,
      redirect_uri: process.env.VUE_APP_REDIRECT_URI,
      loading: false
    };
  },
  methods: {
    handleLogin(){
      setToken(
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9haXpzLm12cDQ1LmNvbVwvYXBpXC9hc3NvY2lhdGVcL3Rlc3QiLCJpYXQiOjE3MDQyNzUyMDEsImV4cCI6MTczNTgxMTIwMSwibmJmIjoxNzA0Mjc1MjAxLCJqdGkiOiJZYkNBYlpBUE8ydDAyaXVaIiwic3ViIjoxODYsInBydiI6IjI0MmJjODE0NTBiOGMwNTcxZmVhYzA0ZTQ5NTY3ZDRhMTZkY2EzMDIifQ.mYza-SXTBLaN6vKoi2i0aLp1wjWNJaL2UcaAwxDZ4_A"
        );
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;
$light_gray2: #7398ac;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $light_gray2;
  display: flex;
  align-items: center;
  justify-content: center;
  // .content_box {
  //   width: 400px;
  //   height: 400px;
  //   background-color: $dark_gray;
  // }
}

.h-\[400px\] {
  height: 400px;
}
</style>

<style rel="stylesheet/scss" lang="scss">
$bg: #2d3a4b;
$light_gray: #eee;
</style>
